const prioritiesTemplate = `
<!DOCTYPE html>
<html>
  <head> </head>
  <body>
    <table id="table-comment"> 
    <h2 class="pdf-table-heading">Priorities</h2>
    
    <h3 class="pdf-section-heading">Key Objectives</h3>
    
    <tr>
      <th>Asset Management</th>
    </tr>
    <tr>
      <td>
      {{{assetManagement}}}
      </td>
    </tr>
    
    <tr>
      <th>Leasing</th>
    </tr>
    <tr>
      <td>
      {{{leasing}}}
      </td>
    </tr>
    
    <tr>
      <th>Building</th>
    </tr>
    <tr>
      <td>
      {{{building}}}
      </td>
    </tr>
    
    <tr>
      <th>Sustainability</th>
    </tr>
    <tr>
      <td>
      {{{sustainability}}}
      </td>
    </tr>
    
    <tr>
      <th>Social</th>
    </tr>
    <tr>
      <td>
      {{{social}}}
      </td>
    </tr>
    
    <tr>
      <th>Other</th>
    </tr>
    <tr>
      <td>
      {{{other}}}
      </td>
    </tr>
    
    <h3 class="pdf-section-heading">Leasing Summary</h3>
    
    <tr>
      <th>Breaks / Expiries</th>
    </tr>
    <tr>
      <td>
      {{{breaksExpiries}}}
      </td>
    </tr>
    
    <tr>
      <th>Regears</th>
    </tr>
    <tr>
      <td>
      {{{regears}}}
      </td>
    </tr>
    
    </table>
  </body>  
</html>
`;

export default prioritiesTemplate;